<template>
  <div>
    <div v-if="cautionNotice">
      <div class="noticeWarning dark:bg-purple-600 border-2 dark:text-white">
        <button
          v-on:click="closeCautionNotice"
          id="button-close"
          class="block float-right relative"
          aria-label="Close"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2"></circle>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
          </svg>
        </button>

        <p
          class="
            text-x
            p-3
            mt-20
            bg-blue-100
            border-solid border
            dark:text-black
            border-blue-500
            rounded-lg
          "
        >
          The Wellness Services Navigator tool is not designed for urgent or
          crisis support. Your activity within this tool, including your
          responses to questions, is not being monitored. If you are worried
          about harm to yourself or others in any way, we urge you to contact
          any of the following immediate supports.
        </p>
        <br />

        <p class="modalPara mt-6 font-bold">For immediate crisis support:</p>
        <ul class="list-inside list-disc">
          <li class="ml-4 mb-3">
            Health and Counselling Services (M-F, 8:30 a.m. to 4:30 p.m.): Present in person to the main clinic, <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-0"
              href="https://carleton.ca/campus/map/#TT">2600 Carleton Technology and Training Centre</a> or call  <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-1"
              href="tel:6135206674"
          >(613) 520-6674</a> (select option #2)
          </li>

          <li class="ml-4 mb-3">
            Good 2 Talk:
            <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-0"
              href="tel:18669255454"
              >1-866-925-5454</a
            >
          </li>
          <li class="ml-4 mb-3">
            Distress Centre of Ottawa and Region:
            <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-1"
              href="tel:6132383311"
              >613-238-3311</a
            >
          </li>
          <li class="ml-4 mb-3">
            Crisis Service Canada:
            <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-1"
              href="tel:18334564566"
              >1-833-456-4566
            </a>
          </li>
          <li class="ml-4">
            Suicide Crisis Helpline:
            <a
                class="text-link-blue dark:text-link-light-blue font-bold pb-1"
                href="tel:988"
            >9-8-8 (call or text)
            </a>
          </li>
        </ul>

        <br />

        <div style="text-align: left">
          <div class="continuumButtonLarge">
            <a
              href="https://wellness.carleton.ca/get-help-now/"
              class="visitWebsiteLink_a_tag"
              style="margin: 0; margin-top: 10px"
              target="_blank"
            >
              Contact Health and Counselling Services
              <span class="arrow">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                    fill="#8380A8"
                  />
                </svg> </span
            ></a>
          </div>

          <div class="continuumButtonSmall">
            <a
              href="https://wellness.carleton.ca/get-help-now/"
              class="visitWebsiteLink_a_tag"
              style="margin: 0; margin-top: 10px"
              target="_blank"
            >
              Services
              <span class="arrow">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                    fill="#8380A8"
                  />
                </svg> </span
            ></a>
          </div>
        </div>
      </div>

      <div
        v-on:click="closeCautionNotice"
        id="background-opacity"
        class="fixed w-full h-full bg-black top-0 bottom-0 opacity-20 z-30"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notice",
  props: ["caution"],
  data() {
    return {
      cautionNotice: true,
      value: {
        type: Boolean,
        required: true,
      },
    };
  },
  methods: {
    closeCautionNotice() {
      //if (!this.forcePageOpen) {
      this.cautionNotice = false;
      if (window.location.href.indexOf("?crisis=true") != -1) {
        let url = window.location.href.split("/?");
        window.location.href = url[0];
      }
      //store.commit("closeWarningDialog");
      // }
    },
  },
};
</script>

<style lang="css" scoped>
.continuumButtonLarge {
  display: block;
}

.continuumButtonSmall {
  display: none;
}
.noticeWarning {
  @apply fixed p-8 bg-white shadow-lg z-50;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: left;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
  width: 50%;
  border-radius: 20px;
}

@media only screen and (max-width: 920px) {
  .noticeWarning {
    width: 75%;
  }
}

@media only screen and (max-width: 640px) {
  .noticeWarning {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    @apply p-8;
  }

  .continuumButtonLarge {
    display: none;
  }

  .continuumButtonSmall {
    display: block;
  }
}

.switch {
  position: relative;
  display: inline-block;
  width: 70px;
  height: 26px;
  top: -2px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider_checkbox {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d34848;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider_checkbox:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider_checkbox::after {
  position: absolute;
  content: "Crisis";

  height: 18px;
  width: 18px;
  left: 25px;
  bottom: 4px;
  top: 0px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider_checkbox {
  background-color: #18c23e;
}

input:focus + .slider_checkbox {
  box-shadow: 0 0 1px #18c23e;
}

input:checked + .slider_checkbox:before {
  -webkit-transform: translateX(43px);
  -ms-transform: translateX(43px);
  transform: translateX(43px);
}

input:checked + .slider_checkbox::after {
  -webkit-transform: translateX(-19px);
  -ms-transform: translateX(-19px);
  transform: translateX(-19px);
}

/* Rounded sliders */
.slider_checkbox.round {
  border-radius: 34px;
}

.slider_checkbox.round:before {
  border-radius: 50%;
}
</style>
